import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Download from './views/Download.vue'
import Contact from './views/Contact.vue'





Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Home
        },
        {
            path: '/download',
            component: Download
        },
        {
            path: '/contact',
            component: Contact
        },
    ]
})
